'use strict';

/**
 * @classname DrawerNav
 * @classdesc SPドロワーナビゲーション
 */
export default class DrawerNav {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--hamburger
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$btn = $e;
		this._$drawer = $('#drawer-nav');
		this._$overlay = $('.drawer-overlay');

		this._$btn.on('click', () => this.drawerOpen());
		this._$overlay.on('click', () => this.drawerClose());
		this._$drawer.find('.btn--drawer-close').on('click', () => this.drawerClose());
		this._$drawer.find('.list__item__link:not([target="_blank"])').on('click', () => this.drawerClose());
	};

	/**
	 * ドロワーを開く
	 *
	 * @memberof DrawerNav
	 * @return undefined
	 */
	drawerOpen() {
		this._$drawer.addClass('is-open');
		this._$overlay.addClass('is-open');
		$('body').css('overflow', 'hidden');
	}

	/**
	 * ドロワーを閉じる
	 *
	 * @memberof DrawerNav
	 * @return undefined
	 */
	drawerClose() {
		this._$drawer.removeClass('is-open');
		this._$overlay.removeClass('is-open');
		$('body').css('overflow', '');
	}
};
